// @flow
import * as React from 'react';
import { Modal } from 'antd';
import Form from './Form';
import AllFiles from './Components/AllFiles';

type Props = {
  emailOptions: [],
  fileList: [],
  allFiles: [],
  selectedPaths: [],
  selectedEmailToOption: [],
  selectedEmailCcOption: [],
  selectedEmailBccOption: [],
  submitting: boolean,
  componentWillMount: (props: any) => void,
  componentWillUnmount: () => void,
  onClickCancel: () => void,
  onClickSubmit: () => void,
  onSearchEmailOptions: Function,
  onSelectEmailOption: Function,
  onAddFile: Function,
  onRemoveFile: Function,
  onChangeSelectedPaths: Function,
}

export default class extends React.PureComponent<Props> {

  componentWillMount = () => this.props.componentWillMount(this.props);

  componentWillUnmount = () => this.props.componentWillUnmount();

  render () {

    const {
      submitting,
      emailOptions,
      fileList,
      allFiles,
      selectedPaths,
      selectedEmailToOption,
      selectedEmailCcOption,
      selectedEmailBccOption,
      onClickCancel,
      onClickSubmit,
      onSearchEmailOptions,
      onSelectEmailOption,
      onAddFile,
      onRemoveFile,
      onChangeSelectedPaths,
    } = this.props;

    return (

      <Modal
        title="Send Valuation"
        visible
        onOk={onClickSubmit}
        onCancel={onClickCancel}
        confirmLoading={submitting}
        okText={`${submitting ? 'Sending Email' : 'Send Email'}`}
        width={650}
      >

        <Form
          emailOptions={emailOptions}
          fileList={fileList}
          selectedEmailToOption={selectedEmailToOption}
          selectedEmailCcOption={selectedEmailCcOption}
          selectedEmailBccOption={selectedEmailBccOption}
          onSearchEmailOptions={onSearchEmailOptions}
          onSelectEmailOption={onSelectEmailOption}
          onAddFile={onAddFile}
          onRemoveFile={onRemoveFile}
        />

        <br />

        <AllFiles
          allFiles={allFiles}
          selectedPaths={selectedPaths}
          onChangeSelectedPaths={onChangeSelectedPaths}
        />

      </Modal>
    )
  }
}
